// Menú del preceptor de una cuenta particular. Por ahora tiene un panel básico: inicio y mensajería.
const buildParticularPreceptorMenuItems = () => ([
  {
    id: 'panel',
    label: 'Inicio',
    icon: 'fas fa-user-shield',
    path: '/particular/preceptor',
    state: { activeMenu: 'panel' }
  },
  {
    id: 'asistencias',
    label: 'Asistencias',
    icon: 'fas fa-clipboard-check',
    path: '/particular/preceptor',
    state: { activeMenu: 'asistencias' }
  },
  {
    id: 'academico',
    label: 'Estado académico',
    icon: 'fas fa-chart-bar',
    path: '/particular/preceptor',
    state: { activeMenu: 'academico' }
  },
  {
    id: 'mensajes',
    label: 'Mensajes',
    icon: 'fas fa-envelope',
    path: '/mensajes',
    state: { scope: 'particulares' }
  }
]);

export { buildParticularPreceptorMenuItems };
export default buildParticularPreceptorMenuItems;
